import { useEffect } from 'react';
import { usePhotoGalleryContainer } from '..';
import styles from './styles/PhotoGallerySlideshowModal.module.scss';
import PhotoGalleryModalControls from './PhotoGalleryModalControls';
import PhotoGalleryModalThumbnails from './PhotoGalleryModalThumbnails';
import PhotoGalleryModalHeroImage from './PhotoGalleryModalHeroImage';
import PhotoGalleryModalDetails from './PhotoGalleryModalDetails';
import MinuteMediaAd from '@/components/ads/MinuteMediaAd';
import { PREVENT_DEFAULT } from './PhotoGalleryThumbnails';

export default function PhotoGallerySlideshowModal() {
  const [{}, { getNextImage, getPreviousImage }] = usePhotoGalleryContainer();

  useEffect(() => {
    function handleKeyDown(event: KeyboardEvent) {
      if (event.key === 'ArrowRight') {
        getNextImage();
      } else if (event.key === 'ArrowLeft') {
        getPreviousImage();
      }
    }

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [getNextImage, getPreviousImage]);

  return (
    <div className={styles.ModalOverlay}>
      <div className={styles.ModalContainer}>
        <div className={styles.ModalContent}>
          <PhotoGalleryModalControls />
          <div className={styles.ModalBodyContainer}>
            <div className={styles.LeftModalContainer} onContextMenu={PREVENT_DEFAULT}>
              <PhotoGalleryModalHeroImage />
              <PhotoGalleryModalThumbnails />
            </div>
            <div className={styles.RightModalContainer}>
              <PhotoGalleryModalDetails />
              <MinuteMediaAd placement="SIDEBAR" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
